<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" class="">
        <v-card elevation="0">
          <v-card-text class="py-2">
            <div class="d-flex">
              <div>
                <span :class="`${item.transactionType}Class`">
                  {{ item.transactionType }}</span
                >
                |
                <span class="tdTextClass"> {{ item.quantity }} Qty </span>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="textStyleMobile" v-if="item.orderTimestamp">
                  {{ getDateFormatted(item.orderTimestamp) }}
                </div>
              </div>
            </div>
            <div class="d-flex py-1">
              <div>
                <div class="securityClass">
                  {{ item.securitySymbol }}
                </div>
              </div>
              <v-spacer></v-spacer>
              <div>
                <div class="priceClass">
                  {{ item.price }}
                </div>
              </div>
            </div>
            <div class="d-flex py-1">
              <div>
                <v-chip class="chipClass">
                  <span>
                    {{ item.orderType }}
                  </span>
                </v-chip>
                <v-chip class="chipClass ml-1 ma-0">
                  <span>
                    {{ getOrderType(item.tradeAction) }}
                  </span>
                </v-chip>
              </div>
              <v-spacer></v-spacer>
              <div>
                <v-chip
                  :class="`${item.status}`"
                  class="commonChipClass text-capitalize ma-0 px-3 py-2"
                >
                  <span>
                    {{ item.status }}
                  </span>
                </v-chip>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "OrdersCard",
  props: {
    item: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    getDateFormatted(date) {
      // console.log(date);
      return this.moment.utc(date).local().format("DD-MMM-YYYY, LT");
    },
    getOrderType(orderType) {
      switch (orderType) {
        case "APPLY_SL":
          return "STOPLOSS";
        case "APPLY_TG":
          return "TARGET";
        default:
          return orderType;
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
* {
  font-family: "Avenir";
}
.btnClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: right;

  color: #2d8cff;
}
.btnTextClass {
  border: 1px solid #2d8cff;
}
.btnTextClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: right;

  color: #2d8cff;
}
.BUYClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  /* Green 2 */

  color: #27ae60;
}
.SELLClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  /* Red */

  color: #eb5757;
}
.securityClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;

  color: #333333;
}

span.v-chip.chipClass {
  background: #f0f3f7;
  border-radius: 4px !important;
}
span.v-chip.chipClass >>> span {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 17px;

  color: #686868;
}
.tdTextClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #575757;
}
span.v-chip.PLACED {
  border: 1px solid #6266bf;
  color: #6266bf;
  background: rgba(98, 102, 191, 0.12);
}
span.v-chip.COMPLETE {
  background: rgba(33, 150, 83, 0.12);
  border: 1px solid #219653;
  color: #219653;
}
span.v-chip.PENDING {
  color: #a19b9b;
  background: rgba(161, 155, 155, 0.12);
  border: 1px solid #a29b9b;
}
span.v-chip.CANCELLED {
  color: #d24646;
  background: rgba(210, 70, 70, 0.12);
  border: 1px solid #d24646;
}
span.v-chip.commonChipClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 17px;
  border-radius: 8px;
  text-transform: capitalize !important;
}
.priceClass {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 14px;
  line-height: 19px;
  text-align: center;

  color: #3d3d3d;
}
span.v-chip.mobileView {
  background: #f0f3f6;
  border-radius: 3px;
}
span.v-chip.mobileViewText {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  line-height: 14px;
}
.textStyleMobile {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  text-align: center;

  color: #575757;
}
@media all and (max-width: 600px) {
  .tdTextClass {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 16px;
    text-align: center;

    color: #575757;
  }
  .BUYClass {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;

    /* Green 2 */

    color: #27ae60;
  }
  .SELLClass {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 12px;
    line-height: 16px;

    /* Red */

    color: #eb5757;
  }
  span.v-chip.commonChipClass {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-weight: 900;
    font-size: 12px;
    line-height: 15px;
    border-radius: 34px;
    text-transform: capitalize !important;
  }
  span.v-chip.commonChipClass >>> span {
    text-transform: capitalize !important;
  }
  span.v-chip.chipClass {
    border-radius: 4px !important;
    background: #f0f3f6;
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 10px;
    line-height: 14px;
    padding-top: 3px !important;
    padding-bottom: 3px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
    /* identical to box height */

    color: #686868;
  }
  span.v-chip.chipClass >>> span {
    font-family: "Avenir";
    font-style: normal;
    font-weight: 900;
    font-size: 10px;
    line-height: 14px;

    color: #686868;
  }
}
</style>
